import { useQuery } from "@tanstack/react-query";
import {
  PlanPackagePromotionDetails,
  PlanPackageUserFieldDetails,
} from "features/types";
import { get, put } from "services/http";
import planPackageServices from "services/planPackage.services";

export interface UpdatePlanPackageUserFieldsRequest {
  planPackageId: number;
  fields: Array<{ fieldId: number; required: boolean }>;
}

export const useFetchPlanPackagesQuery = () => {
  return useQuery(["fetchPlanPackages"], () => planPackageServices.find(), {
    staleTime: Infinity,
  });
};

export const useFetchPlanPackageUserFieldsQuery = (
  planPackageId: number | undefined
) => {
  return useQuery(
    ["fetchPlanPackageUserFields", planPackageId],
    () => {
      return get({
        url: `/plan_packages/fields/${planPackageId}`,
      }) as Promise<Array<PlanPackageUserFieldDetails>>;
    },
    {
      staleTime: 0,
      enabled: !!planPackageId,
    }
  );
};

export const updatePlanPackageUserFieldsFetcher = (
  params: UpdatePlanPackageUserFieldsRequest
) => {
  return put({
    url: `/plan_packages/fields/${params.planPackageId}`,
    params: params.fields,
  });
};

export const useFetchPlanPackagePromotionsQuery = () => {
  return useQuery(
    ["fetchPlanPackagePromotions"],
    () => {
      return get({
        url: "/plan_packages/promotions/list/active",
      }) as Promise<Array<PlanPackagePromotionDetails>>;
    },
    {
      staleTime: Infinity,
    }
  );
};
